<template>
  <div id="regPage">
    <div class="content">
        <div class="regForm">
          <el-form
            label-position="right"
            label-width="160px"
            :model="form"
            :rules="rules"
            ref="form"
            @submit.native.prevent
          >
            <el-col :span="12">
              <el-form-item label="用户账号" prop="userNo" >
                <el-input v-model="form.userNo"  auto-complete="off"
                          placeholder="请填写用户账号(20字内,唯一)"
                          maxlength="20"
                          clearable ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="my-col" :span="12">
              <el-form-item label="运营人名称" prop="operatorName" >
                <el-input v-model=" form.operatorName"    placeholder="请填写运营人名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="my-col" :span="12">
              <el-form-item label="运营人简称" prop="simpleOperatorName" >
                <el-input v-model=" form.simpleOperatorName"   placeholder="请填写运营人简称" minlength="2" maxlength="4"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="my-col" :span="12">
              <el-form-item label="运营人执照号" prop="operatorLicense"  >
                <el-input
                  v-model=" form.operatorLicense"

                  placeholder="请填写运营人执照号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="my-col" :span="12">
              <el-form-item label="运营人注册地" prop="operatorAddress">
                <el-input
                  v-model=" form.operatorAddress"

                  placeholder="请填写运营人注册地"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="my-col" :span="12">
              <el-form-item
                label="无人机数量"
                prop="uavNumber"
                :rules="[{ required: true, message: '请填写无人机数量', trigger: 'blur' }, { validator: this.validateNumber, trigger: 'blur' }]"
              >
                <!-- <el-input-number   v-model=" form.uavNumber" placeholder="请填写无人机数量"
                :controls="false"></el-input-number> -->
                <el-input v-model=" form.uavNumber"   placeholder="请填写无人机数量"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="my-col" :span="12">
              <el-form-item
                label="联系方式"
                prop="phone"
              >
                <el-input v-model=" form.phone"   placeholder="请填写联系方式"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="my-col" :span="12">
              <el-form-item label="法人代表" prop="legalRepre">
                <el-input v-model=" form.legalRepre"   placeholder="请填写法人代表"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="my-col" :span="12">
              <el-form-item label="注册地" prop="registeredAddress">
                <el-input v-model=" form.registeredAddress"   placeholder="请填写注册地"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="my-col" :span="12">
              <el-form-item label="成立日期" prop="incorporationDate">
                <el-date-picker
                  class="formInputClass"
                  v-model=" form.incorporationDate"
                  type="datetime"
                  placeholder="请选择成立日期"
                  maxlength="200"

                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="my-col" :span="12">
              <el-form-item
                label="注册资本（万元）"
                prop="registeredCapital"
                :rules="[{ required: true, message: '请填写注册资本（万元）', trigger: 'blur' }, { validator: this.validateNumber, trigger: 'blur' }]"
              >
                <el-input v-model=" form.registeredCapital"   placeholder="请填写注册资本（万元）"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="经营范围" prop="operatorRange">
                <el-input
                  v-model=" form.operatorRange"

                  placeholder="请填写经营范围"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 20 }"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col class="my-col" :span="12">
              <el-form-item
                label="执照图片"
                prop="pic"
                :rules="[
                { required: this.imgValid,  trigger: 'change',message: '请上传执照图片'}
              ]"
                label-width="180px"
              >
                <el-upload
                  accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,"
                  class="upload-demo"
                  action="#"
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="handleElementPicChange"

                >
                  <img v-if="imageUrl" :src="imageUrl" class="uploaded-image" :title="imgTitle"/>
                  <div v-else class="upload-placeholder">
                    <!-- <i class="el-icon-upload"></i> -->
                    <div class="upload-text">
                      <span>去上传</span>
                    </div>
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
<!--            <el-col class="my-col" :span="12">-->
<!--              <el-form-item label="验证码" prop="code">-->
<!--                <div class="verifyWrap">-->
<!--                  <el-input-->
<!--                    v-model="form.code"-->
<!--                    placeholder="请填写验证码"-->
<!--                    maxlength="20"-->
<!--                    class="verifyInput"-->
<!--                    clearable-->
<!--                    @keyup.enter.native="submit('form')"-->
<!--                  ></el-input>-->
<!--                  <div class="verifyImg" @click="getVerifyCode()">-->
<!--                    <img v-if="verifyCodeImage" :src="'data:image/png;base64,' + verifyCodeImage" alt="" title="点击刷新验证码" />-->
<!--                    <span v-else>获取验证码失败</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
          </el-form>
        </div>
        <div class="formItemBtnRow">
            <el-button @click="handleCancle()" class="cancelBtn">
              取消
            </el-button>
            <el-button
              type="primary"
              @click="submit('form')"
              class="confirmBtn"
              :loading="loading"
            >
              注册
            </el-button>
          </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { setTimeOutInterval } from "@/assets/js/loginInfo.js";
import crypto from "crypto";
import axios from "axios";
import { generateRandomString } from '@/utils/tools.js'

export default {
  data() {
    let validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写密码"));
      } else {
        if (this.form.confirmPassword) {
          this.$refs.form.validateField("confirmPassword");
        }
        callback();
      }
    };
    let validateConfirmPassword = (rule, value, callback) => {
      value = this.form.confirmPassword;
      if (!value) {
        callback(new Error("请确认密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    let checkPhone = (rule, value, callback) => {
      if (value) {
        let regPhone = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/; //11位手机号码正则
        if (!regPhone.test(value)) {
          callback(new Error("手机号格式不正确"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请填写手机号"));
      }
    };
    return {
      imageUrl: "",
      imgValid: true,
      imgTitle: '',
      loading: false,
      verifyCodeImage: '', // 验证码图片
      sessionId: '', // 验证码sessionId
      form: {
        operatorName: "",
        operatorLicense: "",
        operatorAddress: "",
        operatorRange: "",
        uavNumber: "",
        phone: "",
        legalRepre:"",
        registeredAddress:"",
        incorporationDate:"",
        registeredCapital:"",
        simpleOperatorName:"",
      },
      rules: {
        userNo: [
          { required: true, message: "请填写用户账号", trigger: "blur" },
        ],
        operatorName: [
          { required: true, message: "请填写运营人名称", trigger: "blur" },
        ],
        operatorLicense: [
          { required: true, message: "请填写运营人运营人执照号", trigger: "blur" },
        ],
        operatorAddress: [
          { required: true, message: "请填写运营人运营人注册地", trigger: "blur" },
        ],
        legalRepre: [
          { required: true, message: "请填写法人代表", trigger: "blur" },
        ],
        registeredAddress: [
          { required: true, message: "请填写注册地", trigger: "blur" },
        ],
        incorporationDate: [
          { required: true, message: "请填写成立日期", trigger: "blur" },
        ],
        registeredCapital: [
          { required: true, message: "请填写注册资本", trigger: "blur" },
        ],
        operatorRange: [
          { required: true, message: "请填写经营范围", trigger: "blur" },
        ],
        // password: [
        //   { required: true, validator: validatePassword, trigger: "blur" },
        // ],
        // confirmPassword: [
        //   {
        //     required: true,
        //     validator: validateConfirmPassword,
        //     trigger: "blur",
        //   },
        // ],
        phone: [{ required: true, validator: checkPhone, trigger: "blur" }],
        // sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        // address: [{ required: true, message: "请填写地址", trigger: "blur" }],
        // code: [{ required: true, message: "请填写验证码", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 上传图元图片改变时执行的事件
    handleElementPicChange(file) {
      const isJPGPNG = file.type === "image/jpeg" || "image/png";
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isJPGPNG) {
        let tips =
          "<i class='el-icon-warn-tip'></i>" +
          "上传图元图片只能是 JPG 或 png 格式!";
        this.$confirm(tips, "提示", {
          confirmButtonText: "好的",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          showCancelButton: false,
        });
      }
      if (!isLt1M) {
        let tips =
          "<i class='el-icon-warn-tip'></i>" + "上传图元图片大小不能超过 1MB!";
        this.$confirm(tips, "提示", {
          confirmButtonText: "好的",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          showCancelButton: false,
        });
      }

      if (isJPGPNG && isLt1M) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.form.file = file.raw;
        this.$nextTick(() => {
          this.$refs.form.clearValidate('pic'); // 清除校验
          this.imgValid = false
        });
      }
    },
    // 数字校验
    validateNumber(rule, value, callback) {
      if (value === '' || !/^\d+$/.test(value)) {
        callback(new Error('请填写有效的数字'));
      } else {
        callback();
      }
    },
    change(e) {
      this.$forceUpdate();
    },
    // 密码加密函数
    encryption(pwd) {
      let md5 = crypto.createHash("md5");
      md5.update(pwd); //需要加密的密码
      let password = md5.digest("hex"); //password 加密完的密码
      return password;
    },

    // 取消注册
    handleCancle() {
      // 清空注册表单内容 todo
      this.$router.push({ path: "/login" }); //页面跳转
    },
    // 提交表单
    submit(formName) {
      try {
        this.loading = true;
        if(this.form.file){
          this.imgValid = false
          this.$refs.form.clearValidate('pic');
        }
        this.$nextTick(()=>{
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const multiData = this.formatData();
              this.save(multiData);
            } else {
              return false;
            }
          });
        })

      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    formatData() {
      const formData = new FormData();
      const form = this.form;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          const element = form[key];
          if (null != element && 0 < (element + "").trim().length) {
            formData.append(key, element);
          }
        }
      }
      if (this.file) {
        formData.append("file", this.file.raw);
      }
      return formData;
    },
    // 新增
    save(form) {
      // this.postJsonRequest(`/user-server/api/u-user/register?departmentId=1&sessionId=${this.sessionId}`, form).then(
      //   (res) => {
      //     let oData = res.data;
      //     let _this = this;
      //     if (oData.code === 0) {
      //       this.$message({
      //         message: "注册成功，请登录",
      //         duration: 1000,
      //         customClass: "message-s",
      //         iconClass: "el-icon-ok-tip",
      //         offset: 470,
      //         onClose: function () {},
      //       });
      //       this.$router.push({ path: "/login" }); //调转到登录
      //     } else if (oData.code != 401) {
      //       let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
      //       this.$confirm(tips, "提示", {
      //         confirmButtonText: "好的",
      //         customClass: "customClass-style",
      //         iconClass: "",
      //         dangerouslyUseHTMLString: true,
      //         confirmButtonClass: "confirm-style",
      //         showCancelButton: false,
      //       });
      //     } else if (oData.code === 513) {
      //         this.getVerifyCode(); // 刷新验证码
      //         let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
      //         this.$confirm(tips, "提示", {
      //           confirmButtonText: "好的",
      //           customClass: "customClass-style",
      //           iconClass: "",
      //           dangerouslyUseHTMLString: true,
      //           confirmButtonClass: "confirm-style",
      //           showCancelButton: false,
      //         });
      //       }
      //   }
      // );
      this.postJsonRequest(
        "/user-server/Operator/addOperator",
        {...form,incorporationDate:this.$moment(this.form.incorporationDate).format(
            "YYYY-MM-DD HH:mm:ss"
          )}
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.$message({
            message: "注册成功",
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
          });
          this.$router.push({ path: "/login" }); //调转到登录
        }
      });
    },

    // 获取验证码
    getVerifyCode() {
      this.getRequest(`/user-server/api/u-user/generate?sessionId=${this.sessionId}`)
        .then(res => {
          let oData = res.data;
          if (oData.code == 0) {
            this.verifyCodeImage = oData.data; // 存储 Base64 字符串
            // console.log('base64-->', oData.data)
          } else{
            this.verifyCodeImage = ''; // 清空验证码图片
          }
        })
        .catch(error => {
          console.error('请求失败', error);
        });
    },
  },
  mounted() {
    document.getElementsByTagName("body")[0].className = "regbgback";
    // this.getVerifyCode()
  },
};
</script>

<style scoped>
@import "../assets/css/login/register.css";
</style>
<style>
/* 注册页背景设置 */
.regbgback {
  background: url("../assets/img/login/login_bg.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/register.vue